import axios from '@/axios.js'

export default {
  fetchPurchases ({ commit }) { 
    return new Promise((resolve, reject) => {
      axios.get('/purchase/data')
        .then((response) => {
          commit('SET_OPERATIONS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchOperation ({ commit }, userId) {
    return new Promise((resolve, reject) => {
      axios.get(`/operation/data/${userId}`)
        .then((response) => {
          commit('SET_OPERATION', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    }) 
  },
  updateOperation ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/operation/update', item)
        .then((response) => {
          //commit('UPDATE_USERS', item)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  createOperation ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/operation/create', item)
        .then((response) => {
          commit('CREATE_OPERATION', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchOperationProducts ({ commit },idoperation) {
    return new Promise((resolve, reject) => {
      axios.get(`/operations_products/data/`+idoperation)
        .then((response) => {
          commit('SET_OPERATIONPRODUCTS', response.data.products)
          resolve(response.data.products)
        })
        .catch((error) => { reject(error) })
    }) 
  },
  updateItem ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/operations_products/update', item)
        .then((response) => {
          //location.reload(); 
          commit('UPDATE_OPERATIONPRODUCTS', response.data.data.products[0])
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }, 
  createItem ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post('/operations_products/create', item)
        .then((response) => {
          commit('CREATE_OPERATIONS_PRODUCTS', Object.assign(response.data.data.products[0]))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeItem ({ commit }, obj) {
    return new Promise((resolve, reject) => {
      axios.get("/operations_products/product/delete/" + obj.idproduct + "/" + obj.idoperation)
        .then((response) => {
          commit('REMOVE_OPERATIONPRODUCTS', obj.idproduct)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
